//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../Annotations/Annotations.PmiAttributeBuilder.js";
let d=[[[0,"Category",1,0],[0,"DecimalPlace",1,0],[0,"Identifier",1,0],[0,"Revision",1,0],[0,"StringPrefixI",1,0],[0,"StringPrefixJ",1,0],[0,"StringPrefixK",1,0],[0,"StringPrefixLabel",1,0],[0,"StringPrefixLevel",1,0],[0,"StringPrefixX",1,0],[0,"StringPrefixY",1,0],[0,"StringPrefixZ",1,0],[0,"StringSuffixI",1,0],[0,"StringSuffixJ",1,0],[0,"StringSuffixK",1,0],[0,"StringSuffixLabel",1,0],[0,"StringSuffixLevel",1,0],[0,"StringSuffixX",1,0],[0,"StringSuffixY",1,0],[0,"StringSuffixZ",1,0],[0,"Title",1,0],[0,"ToggleI",1,0],[0,"ToggleJ",1,0],[0,"ToggleK",1,0],[0,"ToggleLabel",1,0],[0,"ToggleLevel",1,0],[0,"ToggleX",1,0],[0,"ToggleY",1,0],[0,"ToggleZ",1,0],[0,"TrackingCsys",1,"CoordinateSystem",0],[0,"TrackingPoint",1,"Point",0]],[],[]];
SPLM.Annotations.CoordinateNoteBuilder = class extends SPLM.Annotations.PmiAttributeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.CoordinateNoteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;